import { styled } from '@mui/material/styles';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'reactstrap';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { BreadcrumbItemContextProvider } from '../../provider/BreadcrumbItemContextProvider';
import { NotifyContextProvider } from '../../provider/NotifyContextProvider';
import Breadcrumbs from '../../ui-parts/Breadcrumbs';
import Header from '../MyM901_Header/Header';
import Footer from '../MyM902_Footer/Footer';
import StandardPageTopBar from './StandardPageTopBar';

/**
 * StandardPage Component
 */
const StandardPage = (props) => {

  const screenId = 'MyM903';
  const { controlSettings } = useWebContext(screenId);
  useMyMApi(screenId);

  const StyledMain = styled('main')(() => ({
    display: 'flex',
    flexGrow: 1,
    overflowY: 'auto'
  }));

  return (
    // 2025.7.7 MyMine Version3.0対応 Modify Start
    // 2024.9.16 MyMine Version2.0対応 Modify Start
    <NotifyContextProvider>
      <StandardPageTopBar screenId={screenId} controlSettings={controlSettings} />
      <Header />
      <BreadcrumbItemContextProvider>
        <StyledMain>
          <Container fluid={true}>
            <Breadcrumbs controlSettings={controlSettings} />
            <Outlet />
          </Container>
        </StyledMain>
      </BreadcrumbItemContextProvider>
      <Footer />
    </NotifyContextProvider>
    // 2024.9.16 MyMine Version2.0対応 Modify End
    // 2025.7.7 MyMine Version3.0対応 Modify End
  )
}
export default StandardPage;